import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Video Game Back Log Support</h1>
      <br />
      <h3>
        Thank you for using the Video Game Back Log app. If you require any
        support or have any issues with the app, <br /> please email the support
        team at the email below. Thank you again for using the app.
      </h3>
      <br />
      <a href="mailto: vgbacklog002@gmail.com">
        <h3>vgbacklog002@gmail.com</h3>
      </a>
    </div>
  );
}

export default App;
